import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-border/60 grain"
    >
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 pt-10 pb-16 lg:pt-20 lg:pb-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Text */}
          <div className="lg:col-span-6 fade-up order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#B8935F] font-medium mb-5">
              <Sparkles className="w-3.5 h-3.5" /> Ikerezi Collection · 2026
            </div>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-[84px] leading-[0.98] text-foreground">
              Hair that
              <br />
              <em className="italic font-medium text-[hsl(var(--primary))]">moves</em>{" "}
              <span className="text-foreground/80">with you.</span>
            </h1>
            <p className="mt-6 text-base lg:text-lg text-muted-foreground max-w-xl leading-relaxed">
              Premium human-hair wigs, hand-selected for softness, density and
              natural movement. Filter by length, lace type and color to find
              your signature look.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button
                data-testid="hero-cta-shop"
                asChild
                className="rounded-sm h-12 px-7 bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-[hsl(var(--primary-foreground))]"
              >
                <a href="#catalog">
                  Shop the collection <ArrowRight className="ml-2 w-4 h-4" />
                </a>
              </Button>
              <Button
                data-testid="hero-cta-filters"
                asChild
                variant="outline"
                className="rounded-sm h-12 px-7 border-foreground/30 hover:bg-secondary"
              >
                <a href="#shop-by-length">Shop by length</a>
              </Button>
            </div>

            {/* Trust stats */}
            <div className="mt-14 grid grid-cols-3 max-w-lg gap-6 border-t border-border/60 pt-6">
              {[
                { k: "100%", v: "Human hair" },
                { k: "12+", v: "Styles & cuts" },
                { k: "5★", v: "Customer rated" },
              ].map((s) => (
                <div key={s.v} data-testid={`hero-stat-${s.v}`}>
                  <div className="font-serif text-3xl text-[hsl(var(--primary))]">{s.k}</div>
                  <div className="text-xs uppercase tracking-widest text-muted-foreground mt-1">{s.v}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="lg:col-span-6 relative fade-up order-1 lg:order-2">
            <div className="relative aspect-[4/5] lg:aspect-[5/6] overflow-hidden rounded-sm bg-secondary">
              <img
                data-testid="hero-image"
                src="/api/static/marketing/kay-mousse-warm.jpg"
                alt="Kay's Beauty Hair Mousse"
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--primary))]/25 via-transparent to-transparent" />
            </div>

            {/* Floating featured card */}
            <div
              data-testid="hero-floating-card"
              className="absolute -bottom-6 -left-4 lg:-left-10 bg-[hsl(var(--background))] border border-border/70 px-5 py-3 shadow-[0_12px_40px_-20px_rgba(0,0,0,0.25)] rounded-sm"
            >
              <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Featured</div>
              <a
                href="https://kays-beauty-hair.myshopify.com/products/deep-curl-goddess"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-serif text-lg text-foreground hover:text-[hsl(var(--primary))] transition-colors"
              >
                Deep Curl Goddess
              </a>
              <div className="text-xs text-[#B8935F]">From $69.99</div>
            </div>

            {/* Second floating label */}
            <div className="hidden lg:block absolute top-16 -right-6 bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] px-4 py-3 rounded-sm shadow-[0_12px_40px_-20px_rgba(0,0,0,0.5)]">
              <div className="text-[10px] uppercase tracking-[0.3em] opacity-80">New drop</div>
              <div className="font-serif text-base italic">this season</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
